//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.PostControl.js";
let d=[[[0,"ActiveView",1,0],[0,"Delay",1,0],[0,"JointsLimits",1,0],[0,"PlayMode",1,0]],[[[],"Finish",{},0,0],[["step"],"StepTo",{},1,0],[[],"Solve",{},0,0],[[],"StepForward",{},0,0],[[],"StepBackward",{},0,0],[[],"StepToDesignPosition",{},0,0],[[],"StepToAssemblyPosition",{},0,0],[[],"Stop",{},0,0],[[],"UpdateFromSpreadsheet",{},0,0],[[],"QuitSpreadsheet",{},0,0]],[]];
SPLM.Motion.SpreadsheetRunControl = class extends SPLM.Motion.PostControl{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SpreadsheetRunControl";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;